import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <p>
        &copy; {new Date().getFullYear()} <a href="/">thewickedengineer</a>. Crafted with intent.
      </p>
    </footer>
  );
};

export default Footer;
